import ContactAPI from 'dashboard/api/contacts';
import {
  buildContactEntitySearchTerms,
  doesContactExactlyMatchEntity,
  doesContactMatchEntity,
} from './contactEntity';

const dedupeContactsById = contacts => {
  const contactMap = new Map();

  contacts.forEach(contact => {
    if (contact?.id && !contactMap.has(contact.id)) {
      contactMap.set(contact.id, contact);
    }
  });

  return Array.from(contactMap.values());
};

export const findContactsByEntity = async (type, value) => {
  const searchTerms = buildContactEntitySearchTerms(type, value);
  if (!searchTerms.length) {
    return [];
  }

  const responses = await Promise.all(
    searchTerms.map(term => ContactAPI.search(term))
  );
  const contacts = responses.flatMap(response => response.data?.payload || []);
  const dedupedContacts = dedupeContactsById(contacts).filter(contact =>
    doesContactMatchEntity(type, contact, value)
  );
  const exactMatches = dedupedContacts.filter(contact =>
    doesContactExactlyMatchEntity(type, contact, value)
  );

  if (exactMatches.length) {
    return exactMatches;
  }

  return dedupedContacts;
};
